export type Brand<K, T> = K & { __brand: T };
